import {SvgIconData} from '@shared_web/components/core/svg_icon';

export const icon_maviflex_logo_red_and_grey: SvgIconData = {
  viewBox: '0 0 333.3 68.1',
  element: (
    <>
      <path
        fill="#e4032e"
        d="M64.5,50.3H23.2c-2.3,0-4.2-1.9-4.2-4.2v-28.2h41.3c2.3,0,4.2,1.9,4.2,4.2v28.2Z"
      />
      <g>
        <path
          fill="#fff"
          d="M62.1,21.7v26.7h-6.4v-21.6l-9.8,21.6h-5.8l-11.4-21.5h-7.2v-7.2h11.3l10.3,19.9,8.5-19.9h8.4c1.1,0,2.1,1,2.1,2.1Z"
        />
        <path fill="#fff" d="M28.7,48.2h-5c-1.4,0-2.1-1.1-2.1-2.1v-1.2h7.1v3.3Z" />
        <rect fill="#fff" x="21.6" y="40.6" width="7.1" height="3.3" />
        <rect fill="#fff" x="21.6" y="36.4" width="7.1" height="3.3" />
        <rect fill="#fff" x="21.6" y="32.1" width="7.1" height="3.3" />
        <rect fill="#fff" x="21.6" y="27.9" width="7.1" height="3.3" />
        <rect fill="#e4032e" x="156.5" y="30.4" width="7.7" height="3.8" />
        <rect fill="#e4032e" x="156.5" y="35.2" width="7.7" height="3.8" />
        <rect fill="#e4032e" x="156.5" y="40.1" width="7.7" height="3.8" />
        <rect fill="#e4032e" x="156.5" y="44.9" width="7.7" height="3.8" />
      </g>
      <path fill="#e73439" d="M18.9,17.8h4.2" />
      <path
        fill="#e4032e"
        d="M95.3,30.8l-2.7-3.6h-9.8l5.5-7.8h7.7l20.1,29.5h-7.8l-8.4-11.3h-15.3l-8.6,11.3h-7.7l12.4-18h14.7Z"
      />
      <path
        fill="#e4032e"
        d="M114.5,19.2l15.4,21.7,14.8-21.7h8.9l-20.1,29.6h-7.7l-20.1-29.7h8.7Z"
      />
      <path fill="#e4032e" d="M164.1,19.3v7.8h-7.6v-7.8h7.6Z" />
      <path
        fill="#8d8e8e"
        d="M201.1,27h-14.6c-.9,0-1.6.4-2.1,1.1-.5.8-.8,1.6-.8,2.5h10.2v7.3h-10.2v10.9h-11.7s0-14.5,0-14.5c0-4.5,1.3-8,3.9-10.7,2.6-2.6,6.2-3.9,10.6-3.9h14.6v7.3Z"
      />
      <path
        fill="#8d8e8e"
        d="M231.6,48.9h-17.1c-2.6,0-4.8-.9-6.5-2.6-1.7-1.7-2.6-3.9-2.6-6.5v-20.1h11.7v18.2c0,.8.3,1.6.9,2.4.6.8,1.3,1.2,2,1.2h11.7v7.3Z"
      />
      <path
        fill="#8d8e8e"
        d="M270.3,48.9h-20.4c-4.5,0-8-1.3-10.7-3.9-2.6-2.6-3.9-6.2-3.9-10.7s1.3-8,3.9-10.7,6.2-3.9,10.7-3.9h20.4v7.3h-20.4c-.7,0-1.4.4-2,1.3-.6.8-.9,1.6-.9,2.4h23.3v7.3h-23.3c0,.8.3,1.6.9,2.4.6.8,1.3,1.2,2,1.2h20.4v7.3Z"
      />
      <path
        fill="#8d8e8e"
        d="M314.4,48.9h-11.3l-8.8-8-9.1,8h-11.3v-3l13.2-11.6-13.2-11.7v-2.9h11.3l9.2,8,9.1-8h10.9v3.3l-12.7,11.3,12.7,11.3v3.3Z"
      />
    </>
  ),
};
